var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{directives:[{name:"editable",rawName:"v-editable",value:(_vm.cms),expression:"cms"}],class:[_vm.name],style:(_vm.mainCssVars),attrs:{"id":`${_vm.cms.scroll_id}`}},[_c('grid',{staticClass:"cursor",class:['grid--container', `${_vm.name}__grid`],attrs:{"layout":[
      {
        size: 1,
        columns: 'repeat(12, 1fr)',
        gap: '6px',
      },
      {
        size: 2,
        columns: 'repeat(24, 1fr)',
        gap: '10px',
      },
    ]}},[_c('grid-item',{class:[`${_vm.name}__grid-item`, `${_vm.name}__content`],attrs:{"layout":[
        { size: 1, x: 1, width: 12 },
        { size: 3, x: 1, width: 24 },
      ]}},[_c('a-heading',{key:"heading",class:`${_vm.name}__heading`,attrs:{"cms":_vm.cms}}),_vm._v(" "),(_vm.cms.copy)?_c('div',{class:`${_vm.name}__text`,domProps:{"innerHTML":_vm._s(_vm.$options.filters.markdown(_vm.cms.copy))}}):_vm._e(),_vm._v(" "),_vm._l((_vm.cms.cta),function(item){return _c(item.component,{directives:[{name:"editable",rawName:"v-editable",value:(item),expression:"item"}],key:item._uid,tag:"component",class:`${_vm.name}__cta`,attrs:{"cms":item,"type":"primary"}})})],2),_vm._v(" "),(_vm.cms.style_underline)?_c('grid-item',{class:[`${_vm.name}__grid-item`, `${_vm.name}__underline`],attrs:{"layout":[
        { size: 1, x: 1, width: 2 },
        { size: 3, x: 1, width: 2 },
      ]}}):_vm._e(),_vm._v(" "),_c('grid-item',[_vm._v("\n      "+_vm._s(_vm.cms.text)+"\n    ")])],1),_vm._v(" "),_c('SlideInView',{class:['no-mb'],attrs:{"direction":"up","slide-distance":"100%","threshold":0,"repeat":false,"duration":0.7}},[_c('a-svg-logo',{staticClass:"big-logo"})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }